import React, { useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import CapColumn from "../CapColumn";
import CapSelect from "../CapSelect";
import CapRow from "../CapRow";
import CapLabel from "../CapLabel";
import ConditionNumber from "./ConditionNumber";
import ConditionString from "./ConditionString";
import ConditionMultiSelect from "./ConditionMultiSelect";
import ConditionMultiSelectTree from "./ConditionMultiSelectTree";
import CapButton from "../CapButton";
import CapProductSelection from "../CapProductSelection";
import ConditionSKUUploader from "./ConditionSKUUploader";
import LocaleHoc from "../LocaleHoc";

import { StyledFlexWrapDiv, StyledCapLabel } from "./style";
import {
  INCLUDE,
  EXCLUDE,
  DOUBLE,
  LONG,
  INTEGER,
  STRING,
  MULTI_SELECT,
  MULTI_SELECT_TREE,
  OPERATORS,
  SKU,
  CATEGORY,
  PRODUCT_ATTRIBUTE,
  EXTERNAL_SEARCH_ENABLED_ITEMS,
  CUSTOM_FIELD,
  EXTENDED_FIELD,
  STORE_FILTER,
  CART_PROMOTIONS,
} from "./constants";
import ConditionCustomField from "./ConditionCustomField";
const { CapLabelInline } = CapLabel;

const CapCondition = (props) => {
  const {
    fact,
    dataType,
    treeData,
    conditionExpressionOptions,
    conditionExpression,
    setConditionExpression,
    criteriaOptions,
    criteria,
    setCriteria,
    conditionValidationError,
    setConditionValidationError,
    onSearch,
    hasProductSelection,
    additionalFields,
    handleSelectAdditionalCondition,
    showProductSelectionCriteria,
    isProductMandatory,
    getEntities,
    multiSelectPlaceholder,
    className,
    categoryTreeData,
    searchedCategoryTreeData,
    brandTreeData,
    productTreeData,
    searchedAttributeTreeData,
    showProductSearchLoader,
    allSearchedCatgeories,
    allSearchedAttributes,
    flattenedCategory,
    prefix,
    suffix,
    includeMsg,
    excludeMsg,
    whoseMsg,
    isMsg,
    andMsg,
    inMsg,
    notInMsg,
    lineItemMsg,
    additionalFieldsMsg,
    validateSkuIds,
    plusMinus,
    shouldRemoveOperator,
    removeOperatorsList,
    getEntityDetails,
    uploadFailedError,
    uploadLimitExceeded,
    uploadReqLoader,
    or,
    search: searchMsg,
    searchWithExact: searchWithExactMsg,
    customerSegmentsTreeData,
    conceptTreeData,
    supplementaryProgramsTreeData,
    zoneTreeData,
    storeTreeData,
    searchedStoreTreeData,
    hideNumberAndProductFields, // This flag is to hide some fields for Store profile, Custom fields etc in journey context.
    customFieldConditions,
    setCustomFieldConditions,
    showCustomFieldDropDown,
    setShowCustomFieldDropDown,
    extendedFieldConditions,
    setExtendedFieldConditions,
    showExtendedFieldDropDown,
    setShowExtendedFieldDropDown,
    handleExtendedFieldSelect,
    helpTextMsg,
    storeExternalSearchRequired,
    storeSearchMsg,
    allSearchedStoreValues,
    uploadInProgressMsg,
    uploadStoreDetails,
    unsupportedCsvHeaderMsg,
    csvFileNoEntryTxt,
    downloadedMsg,
    storeUploadInfo,
    onStoreUpload,
    failedStorePathIdentifier,
    blockId,
    storeUploadOnReferenceIds,
    conditionData,
    reuploadFileMsg,
    storeIdsMsg,
    downloadStoreIdMsg,
    downloadStoreIdCodeNameMsg,
    downloadInProgressMsg,
    possibleValuesData,
    getPossibleValuesStatus,
    getCustomFieldValuesStatus,
    getExtendedFieldValuesStatus,
    getSupplementaryProgramsStatus,
    eventContextSelectionOptions,
    eventContextDataOptions,
    useEntryTriggerEventAttribute,
    eventContextSelectionValue,
    setEventContextSelectionValue,
    eventContextData,
    setEventContextData,
  } = props;
  /**
   * Initially if no criteria(include/exclude) is set, set to include by default.
   */
  useEffect(() => {
    if (!criteria) {
      setCriteria(INCLUDE);
    }
  }, []);

  const treeDataMap = {
    BRAND: brandTreeData,
    CATEGORY: categoryTreeData,
    PRODUCT_ATTRIBUTE: productTreeData,
    CUSTOMER_SEGMENT_FILTER: customerSegmentsTreeData,
    CONCEPT_FILTER: conceptTreeData,
    ZONE_FILTER: zoneTreeData,
    STORE_FILTER: storeTreeData,
    SUPPLEMENTARY_PROGRAM_META_SELECTION: supplementaryProgramsTreeData,
  };

  const searchedTreeDataMap = {
    [CATEGORY]: searchedCategoryTreeData,
    [PRODUCT_ATTRIBUTE]: searchedAttributeTreeData,
    [STORE_FILTER]: searchedStoreTreeData,
  };

  const containsCart = prefix?.props?.type === CART_PROMOTIONS;
  const handleCriteriaChange = (value) => {
    setCriteria(value);
  };

  const list = criteriaOptions || [
    { label: includeMsg, value: INCLUDE, key: "0" },
    { label: excludeMsg, value: EXCLUDE, key: "1" },
  ];

  const additionalConditionConditionExpressionOptions = [
    { label: inMsg, value: OPERATORS.IN, key: OPERATORS.IN },
    { label: notInMsg, value: OPERATORS.NOT_IN, key: OPERATORS.NOT_IN },
  ];

  let commonEventContextProps = {
    eventContextDataOptions,
    eventContextSelectionOptions, 
    eventContextSelectionValue,
    setEventContextSelectionValue,
    eventContextData,
    setEventContextData,
  };

  const getOperatorsAndOperand = (additionalConditionFact, additionalConditionDataType, additionalConditionConditionExpression, isAsynchronous, addFieldPlaceholder) => {
    const dataTypeLocal = additionalConditionDataType || dataType;
    const additionalConditionConditionLocal = additionalConditionConditionExpression || conditionExpression;
    const additionalConditionFactLocal = additionalConditionFact || fact;
    const additionalConditionFactTreeData = treeDataMap[additionalConditionFact] || [];
    const treeDataLocal = additionalConditionFactTreeData.length ? additionalConditionFactTreeData : treeData;
    const isExternalSearch = EXTERNAL_SEARCH_ENABLED_ITEMS.includes(additionalConditionFact) || storeExternalSearchRequired;
    if (!dataTypeLocal) return null;
    switch (dataTypeLocal) {
      /** if fact type is among DOUBLE,INTEGER and LONG - map it to ConditionNumber */
      case DOUBLE:
      case INTEGER:
      case LONG:
        return !hideNumberAndProductFields ? 
           (
            <ConditionNumber
              conditionExpressionOptions={conditionExpressionOptions}
              conditionExpression={conditionExpression}
              setConditionExpression={setConditionExpression}
              conditionValidationError={conditionValidationError}
              setConditionValidationError={setConditionValidationError}
              shouldRemoveOperator={shouldRemoveOperator}
              removeOperatorsList={removeOperatorsList}
              useEntryTriggerEventAttribute={useEntryTriggerEventAttribute}
              {...commonEventContextProps}
            />
          ) : null;
      case MULTI_SELECT:
        return (
          <ConditionMultiSelect
            conditionExpressionOptions={conditionExpressionOptions}
            treeData={treeData}
            conditionExpression={conditionExpression}
            setConditionExpression={setConditionExpression}
            conditionValidationError={conditionValidationError}
            setConditionValidationError={setConditionValidationError}
            placeholder={multiSelectPlaceholder}
            specialWidthReqd = {containsCart}
          />
        );
      case MULTI_SELECT_TREE:
        return (
          <ConditionMultiSelectTree
            fact={additionalConditionFactLocal}
            getEntities={getEntities}
            isAsynchronous={isAsynchronous}
            conditionExpressionOptions={additionalConditionConditionExpressionOptions}
            treeData={treeDataLocal}
            searchedTreeData={searchedTreeDataMap[additionalConditionFact] || []}
            conditionExpression={additionalConditionConditionLocal}
            setConditionExpression={setConditionExpression}
            placeholder={addFieldPlaceholder || multiSelectPlaceholder}
            showProductSelectionCriteria={showProductSelectionCriteria}
            getEntityDetails={getEntityDetails}
            uploadFailedError={uploadFailedError}
            uploadLimitExceeded={uploadLimitExceeded}
            uploadReqLoader={uploadReqLoader}
            showProductSearchLoader={showProductSearchLoader?.[additionalConditionFact]}
            or={or}
            onSearch={(searchText) => onSearch(additionalConditionFact, searchText)}
            isExternalSearch={isExternalSearch}
            searchMsg={searchMsg}
            searchWithExactMsg={searchWithExactMsg}
            allSearchedAttributes={allSearchedAttributes}
            allSearchedCatgeories={allSearchedCatgeories}
            flattenedCategory={flattenedCategory}
            helpTextMsg={helpTextMsg}
            storeSearchMsg={storeSearchMsg}
            allSearchedStoreValues={allSearchedStoreValues}
            uploadInProgressMsg={uploadInProgressMsg}
            uploadStoreDetails={uploadStoreDetails}
            unsupportedCsvHeaderMsg={unsupportedCsvHeaderMsg}
            csvFileNoEntryTxt={csvFileNoEntryTxt}
            downloadedMsg={downloadedMsg}
            storeUploadInfo={storeUploadInfo}
            onStoreUpload={onStoreUpload}
            referenceId={conditionExpression?.referenceId}
            failedStorePathIdentifier={failedStorePathIdentifier}
            blockId={blockId}
            storeUploadOnReferenceIds={storeUploadOnReferenceIds}
            conditionData={conditionData}
            storeIdsMsg={storeIdsMsg}
            reuploadFileMsg={reuploadFileMsg}
            storeSource={conditionExpression?.storeSource}
            uploadedStoreIds={conditionExpression?.uploadedStoreIds}
            downloadStoreIdMsg={downloadStoreIdMsg}
            downloadStoreIdCodeNameMsg={downloadStoreIdCodeNameMsg}
            downloadInProgressMsg={downloadInProgressMsg}
            fetchingDataStatus={getSupplementaryProgramsStatus}
          />
        );
      case SKU:
        return (
          <ConditionSKUUploader
            fact={additionalConditionFact}
            validateSkuIds={validateSkuIds}
            conditionExpressionOptions={additionalConditionConditionExpressionOptions}
            conditionExpression={additionalConditionConditionExpression}
            setConditionExpression={setConditionExpression}
            showProductSelectionCriteria={showProductSelectionCriteria}
          />);
      case STRING:
        if(!hideNumberAndProductFields) {
          return (
            <ConditionString
              conditionExpression={conditionExpression}
              setConditionExpression={setConditionExpression}
              useEntryTriggerEventAttribute={useEntryTriggerEventAttribute}
              {...commonEventContextProps}
            />
          );
        }
        return null;
      case CUSTOM_FIELD:
        return (
          <ConditionCustomField
              treeData={treeData}
              dataType={dataType}
              multiSelectPlaceholder={multiSelectPlaceholder}
              customFieldConditions={customFieldConditions}
              setCustomFieldConditions={setCustomFieldConditions}
              showCustomFieldDropDown={showCustomFieldDropDown}
              setShowCustomFieldDropDown={setShowCustomFieldDropDown}
              fetchingDataStatus={getCustomFieldValuesStatus}
              isCustomField
          /> 
        );
      case EXTENDED_FIELD:
        return (
          <ConditionCustomField
              treeData={treeData}
              dataType={dataType}
              inMsg={inMsg}
              multiSelectPlaceholder={multiSelectPlaceholder}
              customFieldConditions={extendedFieldConditions}
              setCustomFieldConditions={setExtendedFieldConditions}
              showCustomFieldDropDown={showExtendedFieldDropDown}
              setShowCustomFieldDropDown={setShowExtendedFieldDropDown}
              conditionValidationError={conditionValidationError}
              setConditionValidationError={setConditionValidationError}
              fetchingDataStatus={getExtendedFieldValuesStatus}
              possibleValuesData={possibleValuesData}
              getPossibleValuesStatus={getPossibleValuesStatus}
              handleExtendedFieldSelect={handleExtendedFieldSelect}
            /> 
        );
      default:
        return null;
    }
  };

  const LabelType = ({ children }) => (
    <CapLabelInline type="label18">
      {children}
    </CapLabelInline>
  );

  const getAdditionalConditions = () => Object.values(additionalFields || {})?.length > 0
    ? Object.values(additionalFields).map(({
      description: additionalConditionDescription,
      factId: additionalConditionFact,
      dataType: additionalConditionDataType,
      expression: additionalConditionConditionExpression,
      isAsynchronous,
      multiSelectPlaceholder: addFieldPlaceholder,
    }, index) => (
      <>
        {
          !hideNumberAndProductFields && (
            <LabelType>{ !index ? lineItemMsg : andMsg }</LabelType>
          )
        }
        {!hideNumberAndProductFields && <StyledCapLabel type="label2">{additionalConditionDescription}</StyledCapLabel>}
        {getOperatorsAndOperand(
          additionalConditionFact,
          additionalConditionDataType,
          additionalConditionConditionExpression,
          isAsynchronous,
          addFieldPlaceholder
        )}
      </>
    )) : null;

  const getSelectedAttributes = () => Object.keys(additionalFields || {}).map((attribute) => attribute);
  return (
    <CapRow
      display="flex"
      className={classnames(className, "cap-condition-wrapper")}
    >
      <CapColumn xs={1}>
        {prefix}
      </CapColumn>
      <CapColumn xs={22}>
        <StyledFlexWrapDiv specialPaddingReqd = {containsCart}>
          <CapSelect
            options={list}
            value={criteria}
            onChange={handleCriteriaChange}
            style={{ width: "100px" }}
            size="medium"
          />
          <CapLabelInline type="label18">{whoseMsg}</CapLabelInline>
          <StyledCapLabel type="label2">{fact}</StyledCapLabel>
          <CapLabelInline type="label18">{isMsg}</CapLabelInline>
          {getOperatorsAndOperand()}
          {getAdditionalConditions()}
          {hasProductSelection && (
            <CapProductSelection
              selectedAttributes={getSelectedAttributes()}
              handleSelect={handleSelectAdditionalCondition}
              placement="bottom"
              isProductMandatory={isProductMandatory}
              target={(
                <CapButton
                  type="flat"
                  has-icon
                  prefix={plusMinus}
                  className="add-condition-button add-btn"
                >
                  {additionalFieldsMsg}
                </CapButton>
              )}
            />
          )}
        </StyledFlexWrapDiv>
      </CapColumn>
      <CapColumn xs={1} className="condition-suffix">
        {suffix}
      </CapColumn>
    </CapRow>
  );
};

CapCondition.defaultProps = {
  conditionValidationError: 'false',
  setConditionValidationError: () => {},
  showProductSelectionCriteria: true,
  shouldRemoveOperator: false,
  removeOperatorsList: [],
  customerSegmentsTreeData: [],
  conceptTreeData: [],
  supplementaryProgramsTreeData: [],
  zoneTreeData: [],
  storeTreeData: [],
  searchedStoreTreeData: [],
  allSearchedStoreValues: [],
  hideNumberAndProductFields: false,
  storeExternalSearchRequired: false,
  uploadStoreDetails: [],
};

CapCondition.propTypes = {
  fact: PropTypes.string,
  dataType: PropTypes.string,
  conditionExpressionOptions: PropTypes.object,
  conditionExpression: PropTypes.object,
  setConditionExpression: PropTypes.func,
  criteriaOptions: PropTypes.array,
  criteria: PropTypes.string,
  setCriteria: PropTypes.func,
  conditionValidationError: PropTypes.string,
  setConditionValidationError: PropTypes.func,
  className: PropTypes.string,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  treeData: PropTypes.array,
  multiSelectPlaceholder: PropTypes.string,
  additionalFields: PropTypes.array,
  categoryTreeData: PropTypes.array,
  searchedCategoryTreeData: PropTypes.array,
  searchedAttributeTreeData: PropTypes.array,
  brandTreeData: PropTypes.array,
  productTreeData: PropTypes.array,
  showProductSearchLoader: PropTypes.bool,
  getEntities: PropTypes.func,
  handleSelectAdditionalCondition: PropTypes.func,
  hasProductSelection: PropTypes.bool,
  validateSkuIds: PropTypes.func,
  showProductSelectionCriteria: PropTypes.bool,
  isProductMandatory: PropTypes.bool,
  onSearch: PropTypes.func,
  allSearchedAttributes: PropTypes.array,
  allSearchedCatgeories: PropTypes.array,
  flattenedCategory: PropTypes.array,
  /**Below fields are added in translations/en.js */
  includeMsg: PropTypes.string,
  excludeMsg: PropTypes.string,
  whoseMsg: PropTypes.string,
  isMsg: PropTypes.string,
  andMsg: PropTypes.string,
  lineItemMsg: PropTypes.string,
  additionalFieldsMsg: PropTypes.string,
  plusMinus: PropTypes.string,
  inMsg: PropTypes.string,
  notInMsg: PropTypes.string,
  shouldRemoveOperator: PropTypes.bool,
  removeOperatorsList: PropTypes.array,
  uploadFailedError: PropTypes.string,
  uploadLimitExceeded: PropTypes.string,
  uploadReqLoader: PropTypes.string,
  or: PropTypes.string,
  search: PropTypes.string,
  searchWithExact: PropTypes.string,
  customerSegmentsTreeData: PropTypes.array,
  hideNumberAndProductFields: PropTypes.bool,
  conceptTreeData: PropTypes.array,
  supplementaryProgramsTreeData: PropTypes.array,
  zoneTreeData: PropTypes.array,
  storeTreeData: PropTypes.array,
  searchedStoreTreeData: PropTypes.array,
  helpTextMsg: PropTypes.object,
  storeExternalSearchRequired: PropTypes.bool,
  storeSearchMsg: PropTypes.string,
  allSearchedStoreValues: PropTypes.array,
  uploadInProgressMsg: PropTypes.string,
  uploadStoreDetails: PropTypes.array,
  unsupportedCsvHeaderMsg: PropTypes.string,
  csvFileNoEntryTxt: PropTypes.string,
  downloadedMsg: PropTypes.string,
  storeUploadOnReferenceIds: PropTypes.object,
  storeUploadInfo: PropTypes.array,
  onStoreUpload: PropTypes.func,
  failedStorePathIdentifier: PropTypes.string,
  blockId: PropTypes.string,
  conditionData: PropTypes.object,
  reuploadFileMsg: PropTypes.string,
  storeIdsMsg: PropTypes.string,
  downloadStoreIdMsg: PropTypes.string,
  downloadStoreIdCodeNameMsg: PropTypes.string,
  downloadInProgressMsg: PropTypes.string,
  extendedFieldConditions: PropTypes.object,
  setExtendedFieldConditions: PropTypes.func,
  showExtendedFieldDropDown: PropTypes.object,
  setShowExtendedFieldDropDown: PropTypes.func,
  possibleValuesData: PropTypes.object,
  getCustomFieldValuesStatus: PropTypes.string,
  getExtendedFieldValuesStatus: PropTypes.string,
  getPossibleValuesStatus: PropTypes.string,
  handleExtendedFieldSelect: PropTypes.func,
};

export default LocaleHoc(CapCondition, { key: "CapCondition" });
